import React from 'react';
import _ from 'lodash';
import {Form, Grid, Header} from 'semantic-ui-react';

import {
  toDisplayDate,
  toSysDate,
  validDate,
  calculateLastNonZeroBudgetPeriod,
  calculatePOPEndDate,
  getFundingStreamType,
  fetchPOPupdate,
} from 'common/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import moment from 'moment-timezone';

const dateConfig = {
  showHours: false,
  showDate: true,
};

const VALID_POP_DATE_FORMATS = ['MM/DD/YYYY', 'YYYY-MM-DD'];

export class PeriodOfPerformanceStartDate extends React.Component {
  constructor(props) {
    super(props);
    const data = _.get(props, 'data', {});

    this.state = data;
  }

  processData() {
    const {
      data,
      originalPeriodOfPerformance,
      isHidden,
      entityDataPath,
      entityType,
      liquidationDeadlinePath,
    } = this.props;
    const {startDate} = this.state;

    // prepopulate if not interacted with
    if (isHidden && !_.isEmpty(data) && !_.isEmpty(startDate)) {
      this.setState({startDate: undefined}, () => {
        this.props.saveManyEntityData(
          [entityDataPath, liquidationDeadlinePath],
          entityType,
          [undefined, undefined]
        );
      });
    } else if (
      !isHidden &&
      _.isEmpty(this.state) &&
      !_.get(data, 'startDate') &&
      _.get(originalPeriodOfPerformance, 'startDate')
    ) {
      this.setState(
        {
          startDate: toDisplayDate(
            _.get(originalPeriodOfPerformance, 'startDate'),
            dateConfig
          ),
        },
        this.handleBlur
      );
    }
  }

  componentDidMount() {
    this.processData();
  }

  componentDidUpdate() {
    this.processData();
  }

  handleChange = (startDate) => {
    this.setState({
      startDate,
    });
  };

  handleBlur = async (toBlur) => {
    const {
      originalPeriodOfPerformance,
      entityDataPath,
      entityType,
      liquidationDeadlinePath,
      closeoutReportingDeadlinePath,
      grant,
      toggles,
    } = this.props;

    if (_.includes(toggles, 'periodOfPerformanceAmendment')) {
      const {fundingOpportunityId} = grant;
      const {fundingStreams, budget} = grant.payload;
      const {fedShare} = budget.share;

      let {startDate} = this.state;

      let periodOfPerformance = {
        startDate,
        endDate: _.get(originalPeriodOfPerformance, 'endDate'),
      };
      let liquidationDeadline = null;
      let closeoutReportingDeadline = null;

      if (validDate(startDate, VALID_POP_DATE_FORMATS)) {
        const payloadUpdate = {
          startDate: toSysDate(startDate),
          fundingStreamType: getFundingStreamType(fundingStreams),
          configId: fundingOpportunityId,
          fedShare,
        };
        const response = await fetchPOPupdate(payloadUpdate, 'amendmentPOP');
        periodOfPerformance = _.get(response, 'periodOfPerformance', null);
        liquidationDeadline = _.get(response, 'liquidationDeadline', null);
        closeoutReportingDeadline = _.get(response, 'closeoutReportingDeadline', null);        
      }

      this.props.saveManyEntityData(
        [entityDataPath, liquidationDeadlinePath, closeoutReportingDeadlinePath],
        entityType,
        [periodOfPerformance, liquidationDeadline, closeoutReportingDeadline],
        toBlur
      );
    } else {
      // everything in this block will be removed once the refactor takes full effect
      const {programId, fundingOpportunityId} = grant;
      const {fundingStreams, budget} = grant.payload;
      const {fedShare} = budget.share;

      let {startDate} = this.state;

      startDate = validDate(startDate, VALID_POP_DATE_FORMATS)
        ? toSysDate(startDate)
        : startDate;

      const calculatedEndDate = toSysDate(
        calculatePOPEndDate(
          programId,
          fundingStreams,
          calculateLastNonZeroBudgetPeriod(fedShare),
          startDate
        )
      );

      const endDate =
        moment.isMoment(calculatedEndDate) && !calculatedEndDate.isValid()
          ? _.get(originalPeriodOfPerformance, 'endDate')
          : calculatedEndDate;

      const liquidationDeadlinefor90Days = [
        '1005',
        '1006',
        '1007',
        '1010',
        '1011',
        '1012',
        '1014',
      ];
      const newLiquidationDeadline = _.includes(
        liquidationDeadlinefor90Days,
        fundingOpportunityId
      );
      const liquidationDeadline = toSysDate(
        moment(endDate).add(newLiquidationDeadline ? 90 : 120, 'days')
      );

      const periodOfPerformance = {
        startDate: startDate,
        endDate: endDate,
      };

      this.props.saveManyEntityData(
        [entityDataPath, liquidationDeadlinePath],
        entityType,
        [periodOfPerformance, liquidationDeadline],
        toBlur
      );
    }
  };

  render() {
    const {
      originalPeriodOfPerformance,
      data,
      validationErrors,
      validationDirtyMap,
      validationId,
    } = this.props;

    let {startDate} = this.state;

    const firstError = _.find(validationErrors, (err) => !err.isValid) || false;
    const errorMessage = firstError ? firstError.message : false;
    const displayError = firstError && validationDirtyMap.dirty;

    const originalStart = toDisplayDate(_.get(originalPeriodOfPerformance, 'startDate'));
    const originalEnd = toDisplayDate(_.get(originalPeriodOfPerformance, 'endDate'));

    startDate = validDate(startDate, VALID_POP_DATE_FORMATS)
      ? toDisplayDate(startDate, dateConfig)
      : startDate;

    const savedStart = toDisplayDate(_.get(data, 'startDate'));
    const savedEnd = toDisplayDate(_.get(data, 'endDate'));

    const startValue = startDate !== undefined ? startDate : originalStart;
    const endValue = savedEnd !== undefined ? savedEnd : originalEnd;

    const isLoaded =
      savedStart !== undefined && originalPeriodOfPerformance !== undefined;

    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column computer={4} tablet={12} mobile={16}>
              <TextBoxField
                id="startDatePeriod"
                title={'Start date'}
                name="startDate"
                label="Start Date (MM/DD/YYYY)"
                value={startValue}
                handleChange={(name, data) => this.handleChange(data.value)}
                handleBlur={() => this.handleBlur(validationId)}
                maxLength={10}
                type="text"
                displayError={displayError}
                errorMessages={errorMessage}
                disable={!isLoaded}
              />
            </Grid.Column>
            <Grid.Column computer={16}>
              <div className="padding-bottom padding-top">
                <p>End date (MM/DD/YYYY)</p>
                <p>{endValue}</p>
              </div>
            </Grid.Column>
            {(savedStart !== originalStart || endValue !== originalEnd) && (
              <Grid.Column
                width={16}
                className="diffingBackground striped--warning padding-top padding-bottom"
              >
                <Header as="h5">Changed in this amendment</Header>
                {savedStart !== originalStart && (
                  <p>
                    Start date from <strong>{originalStart}</strong> to{' '}
                    <strong>{savedStart}</strong>
                  </p>
                )}
                {endValue !== originalEnd && (
                  <p>
                    End date from <strong>{originalEnd}</strong> to{' '}
                    <strong>{endValue}</strong>
                  </p>
                )}
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export default connectDynamic(PeriodOfPerformanceStartDate);
